export const bills = '/bills/donations';
export const bill = (id: number) => `/bills/${id}`;
export const download = '/bills/admin/donations/download';
export const createBillTransaction = '/bill-transaction';
